<style lang="less" scoped>
  .td_left {width: 150px;text-align-last: left;text-indent: 10px;background-color: #fcfcfc;}
  .after {text-align: left;background-color: #fcfcfc;}
  .after .el-button {height: 40px;}
  .f_red {color: red;margin-right: 5px;}
  .f_hid {color: #ffffff;margin-right: 5px;}
  tr,td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
  .tr .td {float: left;}
  .tr {width: 100%;height: 50px;}
  .td {margin-left: 10px;}
  table {border-collapse: collapse;width: 100%;}
  .el-checkbox__inner {border-radius: 50%;}
  .first .introduce {width: 100%;}
  .first /deep/ .el-input {width: 400px;}
  .level /deep/ .el-input {width: 200px;}
  .ssgj_tr /deep/ .el-input {width: 400px;}
  .edui-default /deep/ .edui-editor-iframeholder {height: 40%;}
  .el-form-item {margin-bottom: 0;float: left;}
  .jianjie_tr .el-form-item {width: 100%;}
  .catid_tr .el-form-item:nth-of-type(2) {margin-left: 10px;}
  .tr2 .el-form-item:nth-of-type(2) {margin-left: 10px;}
  /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail {position: absolute;margin: auto;top: -9999px;right: -9999px;bottom: -9999px;left: -9999px;height: auto}
  .formBox {padding-bottom: 70px;}
  .btnfixed {margin: 0px auto;height: 60px;z-index: 19999;}
  .btnfixed .el-button {height: 40px;margin: 10px auto;}
  .btnfixed {position: fixed;bottom: 0;left: 0;right: 0;height: 60px;background: #f8f4f4;margin-left: 240px;background-color: #dff0d8;}
  /deep/.el-form-item__error {font-size: 16px;height: 40px;line-height: 40px;float: right;margin-left: 10px;position:static;padding-top: 0;}
  /deep/.el-icon-close-tip {display: none;}
  /deep/.el-dialog__wrapper {z-index: 20000 !important;}
</style>
<template>
  <div class="first" id="first">
    <el-form ref="form" :model="form" class="formBox">
      <table>
        <tr class="author_tr">
          <td class="td_left">
            <span v-if="isMandatory('username')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>账号类型
          </td>
          <td class="after">
            <el-form-item>
              <el-radio v-model="form.groupid" label="5">个人</el-radio>
              <el-radio v-model="form.groupid" label="6">企业</el-radio>
              <el-radio v-model="form.groupid" label="8">专家</el-radio>
            </el-form-item>
          </td>
        </tr>
        <tr class="author_tr">
          <td class="td_left">
            <span v-if="isMandatory('username')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>账号/手机号码
          </td>
          <td class="after">
            <el-form-item>
              <el-input v-model="form.username"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="author_tr">
          <td class="td_left">
            <span v-if="isMandatory('company')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>公司
          </td>
          <td class="after">
            <el-form-item>
              <el-input v-model="form.company"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="author_tr">
          <td class="td_left">
            <span v-if="isMandatory('passport')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>昵称
          </td>
          <td class="after">
            <el-form-item>
              <el-input v-model="form.passport"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="source_tr">
          <td class="td_left">
            <span v-if="isMandatory('email')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>邮箱
          </td>
          <td class="after">
            <el-form-item>
              <el-input v-model="form.email" class="source"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="source_tr">
          <td class="td_left">
            <span v-if="isMandatory('truename')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>联系人
          </td>
          <td class="after">
            <el-form-item>
              <el-input v-model="form.truename" class="source"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="author_tr">
          <td class="td_left">
            <span v-if="isMandatory('gender')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>性别
          </td>
          <td class="after">
            <el-form-item>
              <el-select clearable v-model="form.gender" class="select classification">
                <el-option v-for="item in options_genderType" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <!-- <tr class="source_tr">
          <td class="td_left">
            <span v-if="isMandatory('mobile')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>手机号码
          </td>
          <td class="after">
            <el-form-item>
              <el-input v-model="form.mobile" class="source"></el-input>
            </el-form-item>
          </td>
        </tr> -->
        <tr class="areaid">
          <td class="td_left">
            <span v-if="isMandatory('areaid')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>地区
          </td>
          <td class="after">
            <el-form-item>
              <el-select clearable v-model="form.areaid" placeholder="请选择所属国家" class="select">
                <el-option v-for="item in ssgj_data" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr class="areaid">
          <td class="td_left">
            <span v-if="isMandatory('areaid')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>组织
          </td>
          <td class="after">
            <el-form-item>
              <el-select clearable v-model="form.organiseid" placeholder="请选择所属组织" class="select">
                <el-option v-for="item in organisedata" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
      </table>
    </el-form>
    <div class="btnfixed">
      <el-button type="success" @click="addfn()" v-if="this.$route.path === '/Membergl'">添加</el-button>
      <el-button type="success" @click="modification" v-else-if="this.$route.path === '/MemberUpdate'">确定</el-button>
      <el-button @click="cancelfn()" v-if="this.$route.path === '/Membergl'">取消</el-button>
      <el-button @click="backtrack" v-else-if="this.$route.path === '/MemberUpdate'">返回</el-button>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex'
export default {
  components: {
  },
  props: ['updataID'],
  data()
  {
    return {
      form: {
        groupid: null,
        username: '',
        company: '',
        passport: '',
        email: '',
        truename: '',
        mobile: '',
        gender: '',
        areaid: '',
        organiseid: null
      },
      options_genderType: [
        {
          value: 0,
          label: '男'
        },
        {
          value: 1,
          label: '女'
        }
      ],
      ssgj_data: [
        { value: 0, label: '不限地区' },
        { value: 2, label: '中国' },
        { value: 3, label: '印度尼西亚' },
        { value: 4, label: '马来西亚' },
        { value: 5, label: '菲律宾' },
        { value: 6, label: '新加坡' },
        { value: 7, label: '泰国' },
        { value: 8, label: '文莱' },
        { value: 9, label: '越南' },
        { value: 10, label: '老挝' },
        { value: 11, label: '缅甸' },
        { value: 12, label: '柬埔寨' },
        { value: 13, label: '其它' },
        { value: 14, label: '东帝汶' }
      ],
      type: 1,
      //表名
      tabname: 'dmcn_member',
      //fld表数据
      fldData: [],
      organisedata: []
    }
  },

  //根据左侧菜单栏获取模块id
  computed:
  {
    ...mapState({
      curID: state => state.NavID
    })
  },

  async created()
  {
    this.fldData = await window.public.validation(this.tabname)
    this.isgetData()
    this.getOrganise()
  },
  methods: {
    //添加
    addfn()
    {
      let obj = {
        cmd: 'add',
        _major: 11,
        _minor: 28,
        retAtt: 1,
        username: this.form.username,
        mobile: this.form.username,
        no: this.form.username,
        passport: this.form.passport,
        company: this.form.company,
        email: this.form.email,
        truename: this.form.truename,
        gender: this.form.gender,
        areaid: this.form.areaid,
        groupid: this.form.groupid,
        organiseid: this.form.organiseid,
        regtime: (Date.parse(new Date()) / 1000)
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '添加失败，请检查是否有未填写的内容或者填写不规范', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '添加成功', type: 'success', customClass: 'mzindex'})
          this.$emit('removeTab')
          this.$store.commit('onIsLb', '1')
        }
      })
    },
    getOrganise()
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 126,
        _exp: 'id > 0',
        orderby: 'addtime desc'
      }
      window.post.getPost(paras).then((ret) =>
      {
        ret.forEach((item) => this.organisedata.push({ value: item.id, label: item.name }))
        this.organisedata.push({ value: 0, label: '中国东盟矿业信息服务平台和广西海外矿业产业联合会' })
      })
    },
    // 获取需要修改的数据
    isgetData()
    {
      if (this.$route.path === '/MemberUpdate')
        this.getData()
    },
    getData()
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 28,
        _exp: 'id=?',
        types: 'i',
        vals: this.updataID
      }
      window.post.getPost(paras).then((ret) =>
      {
        this.form.id = ret[0].id
        this.form.groupid = ret[0].groupid
        this.form.username = ret[0].username
        this.form.no = ret[0].username
        this.form.passport = ret[0].passport
        this.form.company = ret[0].company
        this.form.email = ret[0].email
        this.form.truename = ret[0].truename
        this.form.mobile = ret[0].mobile
        this.form.gender = ret[0].gender
        this.form.areaid = ret[0].areaid
        this.form.organiseid = ret[0].organiseid
      })
    },
    //修改
    modification()
    {
      let obj = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 28,
        retAtt: 1,
        id: this.form.id,
        username: this.form.username,
        groupid: this.form.groupid,
        no: this.form.username,
        passport: this.form.passport,
        email: this.form.email,
        truename: this.form.truename,
        mobile: this.form.mobile,
        gender: this.form.gender,
        areaid: this.form.areaid,
        company: this.form.company,
        organiseid: this.form.organiseid
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '修改失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '修改成功', type: 'success', customClass: 'mzindex'})
          this.dialogVisible = false
          this.$router.push({path: '/Membergl'})
          this.$store.commit('onActiveName', '1')
        }
      })
    },
    //返回
    backtrack()
    {
      this.$router.push({path: '/Membergl'})
      this.$store.commit('onActiveName', '1')
    },
    //取消(移除Tabs页)
    cancelfn()
    {
      this.$emit('removeTab')
    },
    //判断是否必填
    isMandatory(colname)
    {
      return window.public.isMandatory(this.fldData, colname)
    }
  }
}
</script>



// WEBPACK FOOTER //
// static/form/MemberAdd.vue